import template from './print_barcodes.html';
import controller from './print_barcodes.controller';
import './print_barcodes.scss';

let printBarcodesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default printBarcodesComponent;


// WEBPACK FOOTER //
// ./client/app/components/order_packing/print_barcodes/print_barcodes.component.js